<router-outlet />
@if (navigating()) {
  <div class="nav-loading">
    <app-loader [label]="i18n.t('app.loading')" size="lg" />
  </div>
}
<app-error-dialog />
<app-creditos-insuficientes-dialog />
<app-interesse-dialog />
<app-cookie-consent />
